import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../Css/Custom.css";
import Logo from "../Images/CK-Logo-removebg-preview-removebg-preview.png";

function Navbar() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [services, setServices] = useState([]);
  const [serviceItems, setServiceItems] = useState({});
  const [activeDropdown, setActiveDropdown] = useState(null);

  const slugify = (text) => {
    return text
      ?.toLowerCase()
      ?.trim()
      ?.replace(/&/g, "and")
      ?.replace(/[^\w\s-]/g, "")
      ?.replace(/\s+/g, "-");
  };

  // =========================
  // USER DATA
  // =========================
  const fetchUserData = async (userId) => {
    try {
      const response = await axios.get(
        `https://api.compliancekare.com/api/Compliance/GetUserDetail?UserId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      setUserData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
      fetchUserData(29);
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    setIsLoggedIn(false);
    setUserData(null);
  };

  // =========================
  // SERVICE TYPES
  // =========================
  const getServiceTypes = async () => {
    try {
      const { data } = await axios.get(
        "https://api.compliancekare.com/api/Compliance/GetServiceTypes"
      );
      setServices(data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getServiceTypes();
  }, []);

  // =========================
  // SERVICES BY TYPE ID
  // =========================
  const getServicesByTypeId = async (id) => {
    if (serviceItems[id]) return; // prevent duplicate API

    try {
      const { data } = await axios.get(
        `https://api.compliancekare.com/api/Compliance/ServicesByTypeId?ServiceTypeId=${id}`
      );

      setServiceItems((prev) => ({
        ...prev,
        [id]: data.data || [],
      }));
    } catch (error) {
      console.error(error);
    }
  };

  // =========================
  // DROPDOWN CLICK (MOBILE)
  // =========================
  const handleDropdownClick = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
    getServicesByTypeId(id);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top custom-navbar">
      <div className="container">
        
        {/* LOGO */}
        <Link to="/" className="navbar-brand">
          <img src={Logo} alt="logo" className="logo-img" />
        </Link>

        {/* TOGGLE BUTTON */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* NAV ITEMS */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">

            {/* HOME */}
            <li className="nav-item">
              <Link to="/" className="nav-link">HOME</Link>
            </li>

            {/* DYNAMIC SERVICES */}
            {services.map((service) => (
              <li
                className={`nav-item dropdown ${
                  activeDropdown === service.id ? "show" : ""
                }`}
                key={service.id}
              >
                <span
                  className="nav-link dropdown-toggle"
                  onClick={() => handleDropdownClick(service.id)}
                >
                  {service.serviceTypeName}
                </span>

                <ul
                  className={`dropdown-menu ${
                    activeDropdown === service.id ? "show" : ""
                  }`}
                >
                  {serviceItems[service.id]?.length > 0 ? (
                    serviceItems[service.id].map((item) => (
                      <li key={item.id}>
                        <Link
                          to={`/${slugify(
                            service.serviceTypeName
                          )}/${slugify(item.serviceName)}`}
                          className="dropdown-item"
                        >
                          {item.serviceName}
                        </Link>
                      </li>
                    ))
                  ) : (
                    <li className="dropdown-item text-muted">
                      Loading...
                    </li>
                  )}
                </ul>
              </li>
            ))}

            {/* CONTACT */}
            <li className="nav-item">
              <Link to="/contact" className="nav-link">CONTACT</Link>
            </li>

            {/* LOGIN / USER */}
            {isLoggedIn && userData ? (
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  {userData?.data?.name}
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            ) : (
              <li className="nav-item">
                <Link to="/login" className="nav-link">
                  <button
                    type="button"
                    className="btn btn-outline-success"
                    style={{
                      border: "1px solid green",
                      color: "green",
                    }}
                  >
                    LOGIN
                  </button>
                </Link>
              </li>
            )}

          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;